export enum StandaloneIsaCheckbox {
  PRIVACY = 1,
  RETARGETING = 2,
}
